// import React from 'react'

import { useState } from "react";

const LocationFaqComponent = ({ heading, data }) => {
  const [view, setView] = useState(null);

  return (
    <div>
      <div>
        <div className="faq-component">
          <div className="faq-component-main">
            <h4 className="faq-component-heading">
              Frequently Asked <span>Questions?</span>
            </h4>

            <div className="faq-component-content">
              {data &&
                data.map((e, i) => (
                  <div className="faq-component-content-col">
                    <h5
                      onClick={() => setView(view === i ? null : i)}
                      className={`faq-component-question ${
                        view === i ? "faq-component-question-active" : ""
                      }`}
                    >
                      {e.question}
                      {view === i ? (
                        <i
                          onClick={() => setView(null)}
                          class="fa-solid fa-minus"
                        ></i>
                      ) : (
                        <i class="fa-solid fa-plus"></i>
                      )}
                    </h5>
                    {view === i ? (
                      <div className="faq-component-answer">
                        <div>{e.text && e.text.map((e) => <div>{e}</div>)}</div>

                        {e.points && e.points.map((e) => <li>{e}</li>)}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationFaqComponent;
